import { DataType } from '@shared/extension/enums/data-type.enum';
import { StoreName } from '../../enums';
import { FormValue, UserState } from '../../interfaces';
import { User, UserDetails } from '../../models';
import { AbstractLocalStorageService } from '../../services/abstract/abstract-local-storage.service';
import { isUserStudent } from '../../utils';
import { AbstractStore } from './abstract.store';

export abstract class AbstractUserStore extends AbstractStore<UserState> {
  // Main selectors
  readonly forgotPasswordFormValue$ = this.select('forgotPasswordFormValue');
  readonly signInFormValue$ = this.select('signInFormValue');
  readonly user$ = this.select('user');
  readonly userDetails$ = this.select('userDetails');

  // Mapped selectors
  readonly email$ = this.mapValue('userDetails', (value: UserDetails) => value ? value.email : null);
  readonly isSignedIn$ = this.mapValue('user', (value: User) => Boolean(value));
  readonly isStudent$ = this.mapValue('user', (value: User) => isUserStudent(value));
  readonly userId$ = this.mapValue('user', (value: User) => value?.attributes['custom:userID'] || null);

  constructor(protected override localStorageService: AbstractLocalStorageService) {
    super(localStorageService, StoreName.UserStore, {
      forgotPasswordFormValue: [null, DataType.Object],
      signInFormValue: [null, DataType.Object],
      user: [null, DataType.Object],
      userDetails: [null, DataType.Object],
    });
  }

  async setForgotPasswordFormValue(data: FormValue): Promise<void> {
    await this.setValue('forgotPasswordFormValue', data);
  }

  async setSignInFormValue(data: FormValue): Promise<void> {
    await this.setValue('signInFormValue', data);
  }

  async setUser(data: User | null): Promise<void> {
    await this.setValue('user', data);
  }

  async setUserDetails(data: UserDetails | null): Promise<void> {
    await this.setValue('userDetails', data);
  }
}
